import { cn } from "@/utils/cn";
import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: ReactNode;
}

export function Card({
  children,
  className,
  title,
  description,
  action,
}: CardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-[#E2E8F0] rounded-xl shadow-sm overflow-hidden transition-colors duration-200",
        className
      )}
    >
      {(title || action) && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div>
            {title && (
              <h3 className="text-base font-semibold text-[#1A1F2C]">
                {title}
              </h3>
            )}
            {description && (
              <p className="text-sm text-[#5A6A85] mt-0.5">
                {description}
              </p>
            )}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}
